//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import {
  ContainerType,
  IDataSourceResponse,
  IDataSourcesCreateSourceRequest,
  IDataSourcesResponse,
  IDataSourcesSearchRequest,
} from '@apis/data-sources/dataSourcesApiModels';
import { gatewayFetch } from '@utils/sessionFetch';

const DATA_SOURCES_BASE_URL = '/api/v1/data-sources/';

function dataSourcesGatewayFetch(endpoint: string, init?: RequestInit): Promise<Response> {
  return gatewayFetch('experience_gateway', endpoint, init);
}

/**
 * Get data sources
 *
 * @param sourceType The optional container sourceType to filter results by
 *
 * @returns List of data sources with the given name
 */
export const getDataSources = async (sourceType?: ContainerType): Promise<IDataSourcesResponse> => {
  const params = sourceType ? $.param({ sourceType }) : '';
  const endpoint = sourceType ? `${DATA_SOURCES_BASE_URL}/?${params}` : DATA_SOURCES_BASE_URL;
  const res = await dataSourcesGatewayFetch(endpoint);
  return await res.json();
};

/**
 * Searches for data sources
 *
 * @param request Object with searchable criteria
 *
 * @returns List of data sources
 */
export const searchDataSources = async (request: IDataSourcesSearchRequest): Promise<IDataSourcesResponse> => {
  const res = await dataSourcesGatewayFetch(`${DATA_SOURCES_BASE_URL}search`, {
    method: 'POST',
    body: JSON.stringify({
      ...request
    }),
  });

  return await res.json();
};

/**
 * Creates a data source with the given name and reelId
 *
 * @param name The name for the data source
 * @param reelId The reelId for the data source
 *
 * @returns The created data source
 */
export const createDataSource = async (
  request: IDataSourcesCreateSourceRequest
): Promise<IDataSourceResponse> => {
  const res = await dataSourcesGatewayFetch(`${DATA_SOURCES_BASE_URL}`, {
    method: 'POST',
    body: JSON.stringify({
      config: {
        ...request
      }
    }),
  });

  return await res.json();
};
